module.exports = __webpack_public_path__ + "img/assistenza-strutture-bg.3092c0ec.jpg";